import { ITaskParams } from 'interfaces/task';

const DEFAULT_PAGINATION = {
  page: 1,
  page_size: 10,
};

const DEFAULT_QUERY_PARAMS: ITaskParams = {
  ...DEFAULT_PAGINATION,
  sort_by: 'id',
  order: 'desc',
};

const ETaskStatus = {
  ACTIVE: 'Hoạt động',
  INACTIVE: 'Ngừng hoạt động',
};

const TASK_STATUS: { [key: string]: any } = {
  [ETaskStatus.ACTIVE]: {
    id: 0,
    text: 'Hoạt động',
    code: ETaskStatus.ACTIVE,
    color: '#30CD60',
  },
  [ETaskStatus.INACTIVE]: {
    id: 1,
    text: 'Ngừng hoạt động',
    code: ETaskStatus.INACTIVE,
    color: '#FF0F00',
  },
};

const PROCESSING_STATUS = {
  CLOSE: {
    text: 'Đã đóng',
    color: '#FF0F00',
  },
  OPEN: {
    text: 'Đang mở',
    color: '#53c305',
  },
};

export enum ETicketStatus {
  EXPIRED = 1,
  GONNA_OVER_DUE = 2,
  IN_TIME = 3,
  ALL = 4,
}

export enum EIssueTypeStatus {
  ACTIVE = 1,
  INACTIVE = 2,
}
const TYPE_IMAGES = ['image/png', ' image/jpg', 'image/jpeg', 'image/heif'];
const URL_LOCAL = 'http://minio.sre-system:9000';
const URL_MINIO_PUBLIC = 'https://minio.dgl-dev.teko.vn/sale-portal-bff/';
const API_PREVENT_NOTI_ERR = ['/ticket/updateMerchantContractMCA'];
const CODE_PREVENT_NOTI_ERR = ['079', '192', 401];

export enum IssueTypeTypeOf {
  APPROACH = '0',
  ASSIGN = '1',
  POS365 = '2',
  SAPO = '3',
  SALE_MACHINE = '4',
  RENTING = '5',
  ADD_PROFILE_MC = '6',
}

export default {
  TASK_STATUS,
  DEFAULT_QUERY_PARAMS,
  ETicketStatus,
  MAX_FILE: 20,
  MAX_COUNT: 3,
  TYPE_IMAGES,
  ONE_KB: 1024,
  PROCESSING_STATUS,
  URL_LOCAL,
  URL_MINIO_PUBLIC,
  IssueTypeTypeOf,
  MIN_IMAGE: 2,
  API_PREVENT_NOTI_ERR,
  CODE_PREVENT_NOTI_ERR,
  MAX_PER_FILE: 25,
  MAX_TOTAL_SIZE: 20,
};
